import { createReducer } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';

import { REGISTRATIONS_RESET } from './registrations.const';
import registrationsDetailReducer from './registrationsDetail/registrationsDetail.reducer';
import registrationsListReducer from './registrationsList/registrationsList.reducer';
import registrationsTypesReducer from './registrationTypes';

const initialState = {};

const combinedReducers = combineReducers({
  detail: registrationsDetailReducer,
  list: registrationsListReducer,
  types: registrationsTypesReducer,
});

const registrationsRootReducer = createReducer(initialState, builder => {
  builder.addCase(REGISTRATIONS_RESET, () => initialState).addDefaultCase(() => {});
});

export default (state = initialState, action) => {
  const newState = registrationsRootReducer(state, action);
  return combinedReducers(newState, action);
};
